import {
  Sheet,
  SheetContentResizable,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { useLocalStorageValue } from '@react-hookz/web';
import { QuoteSheetDetails } from './quote-sheet-detail';
import { T } from 'gt-react';

export function QuoteSheetDetailSlidein({
  isOpen: isDetailViewOpen,
  onOpenChange,
  quoteSheetId,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  quoteSheetId?: string;
}) {
  const { value: detailViewSize, set: setDetailViewSize } =
    useLocalStorageValue<number>('quote-sheet-detail-view-size', {
      defaultValue: 50,
      initializeWithValue: true,
    });

  return (
    <Sheet open={isDetailViewOpen} onOpenChange={onOpenChange}>
      <SheetContentResizable
        resizableProps={{
          defaultSize: detailViewSize ?? 50,
          onResize: (size: number) => {
            setDetailViewSize(size);
          },
          className: 'flex flex-col',
        }}
      >
        <SheetHeader className="shrink-0 grow-0">
          <SheetTitle>
            <T context="title for the quote sheet detail panel">Quote Sheet</T>
          </SheetTitle>
        </SheetHeader>
        {quoteSheetId && <QuoteSheetDetails quoteSheetId={quoteSheetId} />}
        <SheetFooter className="shrink-0 grow-0 flex items-end border-t">
          <Button
            onClick={() => {
              onOpenChange(false);
            }}
            className="w-fit"
          >
            <T context="button label to save and close the quote sheet detail panel">
              Save
            </T>
          </Button>
        </SheetFooter>
      </SheetContentResizable>
    </Sheet>
  );
}
